import { createFileRoute } from '@tanstack/react-router';

import { RkTransactionsGrid } from '../../components';

const TransactionExportsPage = () => <RkTransactionsGrid mode='exports' />;

export const Route = createFileRoute('/participant-transactions/exports')({
  component: TransactionExportsPage
});
